import { gql } from "@apollo/client";

export default gql`
  mutation RecoverCustomer($email: String!) {
    recoverCustomer(email: $email)
  }
`;
